export default {
  labels: {
    order: 'Order',
    customer: 'Customer',
  },
  tags: {
    new_customer: 'New Customer',
    loyal_customer: 'Loyal Customer',
  },
};
